import React, { useState, useEffect } from "react";
import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import axios from "axios";
import { useLocation } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
const Singlecourse = () => {
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  
  const [data, setData] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [editedText, setEditedText] = useState("");
  const [editedDuration, setEditedDuration] = useState("");
  const [editedFees, setEditedFees] = useState("");
  const [editedEligibility, setEditedEligibility] = useState("");
  const [editedUniversities, setEditedUniversities] = useState("");
  const [editedAbout, setEditedAbout] = useState("");
  const [editedFullform, setEditedFullform] = useState("");
  const [editedImageUrl, setEditedImageUrl] = useState(""); // State for the image file
  const [editedKeywords, setEditedKeywords] = useState(data.keywords?.join(', ') || '');
  const [error, setError] = useState("");
  const fetchData = async () => {
    try {
      // Start loading
      const response = await axios.get(
        `https://api.mecdistanceeducation.com/api/courses/find/${id}`
      );
      console.log("response", response);

      setData(response.data); // Save the fetched data to state

      console.log("data", response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, [id]);
  // const updatedData = {
  //   ...otherFields,
  //   keywords: editedKeywords.split(',').map(k => k.trim()).filter(Boolean),
  // };
  
  // useEffect(() => {
  //   // Update state only when data is available
  //   if (data) {
  //     setEditedName(data.name);
  //     setEditedText(data.text);
  //     setEditedImageUrl(data.imageUrl);
  //   }
  // }, [data]);
  // const handleFileChange = async (e) => {
  //   const selectedFile = e.target.files[0];
  //   if (!selectedFile) return;

  //   const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
  //   if (!allowedTypes.includes(selectedFile.type)) {
  //     setError("Only image files (JPEG, PNG, JPG) are allowed!");
  //     return;
  //   }

  //   // setImage(selectedFile);

  //   // Upload the image to the backend
  //   const formData = new FormData();
  //   formData.append("image", selectedFile);

  //   try {
  //     const res = await axios.post(
  //       "https://api.mecdistanceeducation.com/api/upload",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     console.log("res.data.imageUrl", res.data.imageUrl);

  //     setEditedImageUrl(res.data.imageUrl); // Save the uploaded image URL
  //   } catch (err) {
  //     console.log(err);
  //     setError("Failed to upload image. Please try again.");
  //   }
  // };
  // Initialize state with current data when entering edit mode
  const handleEditClick = () => {
    setEditMode(true);
    setEditedName(data.name);
    setEditedText(data.text);
    setEditedDuration(data.duration);
    setEditedFees(data.fees);
    setEditedEligibility(data.eligibility);
    setEditedUniversities(data.universities);
    setEditedAbout(data.about);
    setEditedFullform(data.fullform);
    setEditedKeywords(data.keywords);
    // setEditedImageUrl(data.imageUrl);
  };

  const handleSaveChanges = async () => {
    try {
      // const updatedData = {
      //   name: editedName,
      //   text: editedText,
      //   duration: editedDuration,
      //   fees: editedFees,
      //   eligibility: editedEligibility,
      //   universities: editedUniversities,
      //   about: editedAbout,
      //   fullform: editedFullform
      // };

      // Handle image upload if there's a new image
      // const formData = new FormData();
      // if (editedImageUrl) {
      //   formData.append("imageUrl", editedImageUrl);
      // }

      const updatedCourse = {
        name: editedName,
        text: editedText,
        duration: editedDuration,
        fees: editedFees,
        eligibility: editedEligibility,
        universities: editedUniversities,
        about: editedAbout,
        fullform: editedFullform,
        keywords: editedKeywords.split(',').map(k => k.trim()).filter(Boolean),
        // imageUrl: editedImageUrl,
      };
      console.log("updatedCourse", updatedCourse);
      const token = localStorage.getItem("access_token"); // Retrieve token from localStorage

      // Send a PUT request to update the data and the image
      const response = await axios.put(
        `https://api.mecdistanceeducation.com/api/courses/${data._id}`,
        updatedCourse,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Attach token in the request header
            // "Content-Type": "multipart/form-data", // Set the correct content type for file upload
          },
        }
      );

      // Handle the response as needed
      console.log("Updated data:", response.data);

      setEditMode(false); // Exit edit mode
      // window.location.reload(); // Reload page to reflect changes
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="editButton" onClick={handleEditClick}>
              Edit
            </div>
            <div className="item">
              <div className={`details ${editMode ? "editMode" : ""}`}>
                <div className="detailItem">
                  <span className="itemKey">Name:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedName}
                      onChange={(e) => setEditedName(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.name}</span>
                  )}
                </div>
                <div className="detailItem">
                  <span className="itemKey">ID:</span>
                  <span className="itemValue">{data._id}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Text:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedText}
                      onChange={(e) => setEditedText(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.text}</span>
                  )}
                </div>
                <div className="detailItem">
                  <span className="itemKey">Duration:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedDuration}
                      onChange={(e) => setEditedDuration(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.duration}</span>
                  )}
                </div>

                <div className="detailItem">
                  <span className="itemKey">Fees:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedFees}
                      onChange={(e) => setEditedFees(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.fees}</span>
                  )}
                </div>

                <div className="detailItem">
                  <span className="itemKey">Eligibility:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedEligibility}
                      onChange={(e) => setEditedEligibility(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.eligibility}</span>
                  )}
                </div>

                <div className="detailItem">
                  <span className="itemKey">Universities:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedUniversities}
                      onChange={(e) => setEditedUniversities(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.universities}</span>
                  )}
                </div>

                <div className="detailItem">
                  <span className="itemKey">About:</span>
                  {editMode ? (
                    <textarea
                      // className="editInput"
                      type="text"
                      rows="10"
                      cols="100"
                      value={editedAbout}
                      onChange={(e) => setEditedAbout(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.about}</span>
                  )}
                </div>

                <div className="detailItem">
                  <span className="itemKey">Fullform:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedFullform}
                      onChange={(e) => setEditedFullform(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.fullform}</span>
                  )}
                </div>
                <div className="detailItem">
                  <span className="itemKey">Keywords:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedKeywords}
                      onChange={(e) => setEditedKeywords(e.target.value)}
                      placeholder="Comma-separated keywords"
                    />
                  ) : (
                    <span className="itemValue">
                      {data.keywords?.join(", ")}
                    </span>
                  )}
                </div>

                {/* Display Image in View Mode */}
                {/* <div className="detailItem">
                  <span className="itemKey">Image:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="file"
                      onChange={handleFileChange}
                    />
                  ) : (
                    <img
                      src={data.imageUrl} // Display the image
                      alt="Course"
                      className="itemImage"
                      style={{ width: "50%" }}
                    />
                  )}
                </div> */}
              </div>
            </div>
          </div>

          {editMode && (
            <button onClick={handleSaveChanges}>Save Changes</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Singlecourse;
